
export default function RedFlagsSection() {
  const redFlags = [
    {
      icon: "ri-error-warning-line",
      title: "Promises Unusually Large Refunds",
      description: "Any preparer who guarantees a specific refund amount before reviewing your documents is either dishonest or reckless. Legitimate professionals never make refund promises because the outcome depends entirely on your unique financial situation."
    },
    {
      icon: "ri-ghost-line",
      title: "No PTIN or Visible Credentials",
      description: "Every paid tax preparer is legally required to have a Preparer Tax Identification Number. If someone cannot or will not provide their PTIN, walk away immediately. This is non-negotiable in El Paso TX or anywhere else."
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Fees Based on Refund Percentage",
      description: "Tying compensation to your refund amount creates a dangerous incentive to inflate deductions or fabricate credits. This practice is a hallmark of predatory preparers and should disqualify any service from your consideration."
    },
    {
      icon: "ri-file-damage-line",
      title: "Asks You to Sign a Blank Return",
      description: "You should never sign a tax return that is incomplete or that you have not reviewed thoroughly. A preparer who asks you to sign blank forms is likely planning to manipulate the return after you leave."
    },
    {
      icon: "ri-eye-off-line",
      title: "Refuses to E-File or Sign the Return",
      description: "Paid preparers are required by law to sign returns they prepare and include their PTIN. A preparer who refuses to sign or insists on paper filing may be trying to avoid accountability for their work."
    },
    {
      icon: "ri-calendar-close-line",
      title: "Only Available During Tax Season",
      description: "If a preparer disappears from May through December, who handles IRS notices that arrive in July? Who helps with estimated payments due in September? Year-round availability is essential for proper tax management."
    }
  ];

  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-900 mb-4">5. Red Flags to Watch For When Choosing a Tax Preparer</h2>
      <p className="text-gray-600 leading-relaxed mb-8 max-w-3xl">
        Knowing what to avoid is just as important as knowing what to look for. When you <strong>compare tax preparation services</strong> across <strong>El Paso TX</strong>, watch for these warning signs that indicate an unqualified or unethical preparer.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {redFlags.map((flag, index) => (
          <div key={index} className="bg-red-50/60 border border-red-100 rounded-xl p-6 hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-4">
              <i className={`${flag.icon} text-xl text-red-500`}></i>
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-2">{flag.title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{flag.description}</p>
          </div>
        ))}
      </div>

      <div className="w-full h-72 rounded-2xl overflow-hidden shadow-lg">
        <img
          src="https://public.readdy.ai/ai/img_res/5f377c6aceccceb01a1f1fb19ba547af.jpg"
          alt="red-flags-choosing-tax-preparer-el-paso-tx"
          title="Red Flags When Choosing a Tax Preparer in El Paso TX"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}
